<template>
  <div :class="aligen=='vertical'?'':'ksm-thumbnail__page--wrapper'">
    <!-- horizontal -->
    <div v-if="aligen!='vertical'" class="ksm-thumbnail__page">
      <div style="flex:0 0 30px; height:100%;"></div>
      <img
        v-for="(s,i) in seiten" v-if="s.variante==''"
        :title="s.name"
        class="ksm-thumbnail ksm-thumbnail--horizontal"
        :style="'height:'+(imageHeight?imageHeight:125)+'px'"
        :key="'h'+i"
        :class="i==seiteIdx?('active '+modus):modus"
        :src="s.thumbnailSrc"
        @click="selectItem(i)"
      >
      <div style="flex:0 0 30px; height:100%"></div>
    </div>
    <!-- vertical -->
    <div v-if="aligen=='vertical'">
      <div v-for="(s,i) in seiten" :key="'v'+i" style="text-align:center">
        <img
          class="ksm-thumbnail ksm-thumbnail--vertical"
          :class="i==seiteIdx?('active '+modus):modus"
          :src="s.thumbnailSrc"
          @click="selectItem(i)"
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    seiteIdx: Number,
    seiten: Array,
    aligen: String,
    imageHeight: Number
  },
  data() {
    return {};
  },
  watch: {
    thumbnailSrc() {
      const vue = this;
      setTimeout(function() {
        const i = vue.seiteIdx;
        let imgElemente = vue.$el.querySelectorAll(".ksm-thumbnail");
        if (imgElemente && imgElemente[i]) {
          imgElemente[i].scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    },
    seiteIdx(i) {
      // let imgElemente = this.$el.querySelectorAll(".ksm-thumbnail");
      // if (imgElemente && imgElemente[i]) {
      //   setTimeout(function() {
      //     imgElemente[i].scrollIntoView({ behavior: "smooth" });
      //   }, 100);
      // }
    }
  },

  mounted: function() {},
  methods: {
    selectItem(i) {
      this.$emit("selectItem", i);
    }
  },
  computed: {
    modus() {
      const m = this.$route.params.modus;
      return m ? m : "default";
    },
    seite() {
      if (!this.seiten) {
        return;
      }
      return this.seiten[this.seiteIdx];
    },
    thumbnailSrc() {
      if (!this.seite) {
        return;
      }
      return this.seite.thumbnailSrc;
    }
  }
};
</script>

<style lang="scss"
 scoped>
.ksm-thumbnail__page--wrapper {
  @extend .ksm-flex-1;
  @extend .ksm-disable-select;
  position: relative;
}

.ksm-thumbnail__page {
  overflow: auto;
  @extend .ksm-flex;
  @extend .ksm-position-absolute;
}

.ksm-thumbnail--base {
  border: 3px solid #eee;
  margin: 0px 2px;
  cursor: pointer;

  //hover
  &:hover.ansichtsmodus {
    border: 3px solid $ansicht-color;
  }

  &:hover.vergleichsmodus {
    border: 3px solid $vergleich-color;
  }

  &:hover.untersuchungsmodus {
    border: 3px solid $untersuchung-color;
  }

  &:hover.kompositionsmodus {
    border: 3px solid $komposition-color;
  }
  // &:hover.default {
  // border: 3px solid $komposition-color;
  // }

  //active
  &.active.ansichtsmodus {
    border: 3px solid $ansicht-color;
  }

  &.active.vergleichsmodus {
    border: 3px solid $vergleich-color;
  }
  &.active.untersuchungsmodus {
    border: 3px solid $untersuchung-color;
  }
  &.active.kompositionsmodus {
    border: 3px solid $komposition-color;
  }
  &.active.default {
    border: 2px solid gray;
  }
}

.ksm-thumbnail--horizontal {
  @extend .ksm-thumbnail--base;
  flex: 0 0 auto;
}
.ksm-thumbnail--vertical {
  @extend .ksm-thumbnail--base;
  max-height: 150px;
}
</style>


// WEBPACK FOOTER //
// Thumbnail.vue?4b1d3b7f